export const OPERATIONAL_TIMEZONE = 'Africa/Harare';
export const OPERATIONAL_TIMEZONE_EQUIVALENT = 'Africa/Pretoria';
export const OPERATIONAL_TIMEZONE_LABEL = `${OPERATIONAL_TIMEZONE} / ${OPERATIONAL_TIMEZONE_EQUIVALENT}`;

const OPERATIONAL_DATE_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: OPERATIONAL_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const getOperationalDateIso = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = OPERATIONAL_DATE_FORMATTER.formatToParts(date);
  const year = parts.find((part) => part.type === 'year')?.value;
  const month = parts.find((part) => part.type === 'month')?.value;
  const day = parts.find((part) => part.type === 'day')?.value;
  return year && month && day ? `${year}-${month}-${day}` : '';
};

export const normalizeOperationalDateIso = (value) => {
  const direct = String(value || '').trim().slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(direct)) return direct;
  return getOperationalDateIso(value);
};

export const buildBirthdayDismissSessionKey = ({ userId, dateIso }) => (
  `payroll-birthday-dismissed::${userId || 'anonymous'}::${normalizeOperationalDateIso(dateIso) || getOperationalDateIso()}`
);

export const isBirthdayDismissedForSession = ({ userId, dateIso }) => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(buildBirthdayDismissSessionKey({ userId, dateIso })) === 'true';
};

export const dismissBirthdayForSession = ({ userId, dateIso }) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(buildBirthdayDismissSessionKey({ userId, dateIso }), 'true');
};